// Stub: expo-location — GPS not available on desktop (no persistent tracking)
// One-shot getCurrentPositionAsync uses the browser Geolocation API when available.
const denied = () => Promise.resolve({ status: 'denied', granted: false, canAskAgain: false });

export const getForegroundPermissionsAsync  = denied;
export const getBackgroundPermissionsAsync  = denied;
export const requestForegroundPermissionsAsync = () => {
  if (typeof navigator === 'undefined' || !navigator.geolocation)
    return Promise.resolve({ status: 'denied', granted: false });
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      () => resolve({ status: 'granted', granted: true }),
      () => resolve({ status: 'denied',  granted: false }),
      { timeout: 5000 },
    );
  });
};
export const requestBackgroundPermissionsAsync = denied;

export const getCurrentPositionAsync = (options = {}) =>
  new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation)
      return reject(new Error('Geolocation not available'));
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({
        coords: {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          altitude: pos.coords.altitude ?? null,
          accuracy: pos.coords.accuracy,
          altitudeAccuracy: pos.coords.altitudeAccuracy ?? null,
          heading: pos.coords.heading ?? null,
          speed: pos.coords.speed ?? null,
        },
        timestamp: pos.timestamp,
      }),
      (err) => reject(err),
      { enableHighAccuracy: options.accuracy === 'high', timeout: 10000 },
    );
  });

export const watchPositionAsync           = () => ({ remove: () => {} });
export const stopLocationUpdatesAsync     = () => Promise.resolve();
export const startLocationUpdatesAsync    = () => Promise.resolve();
export const hasStartedLocationUpdatesAsync = () => Promise.resolve(false);
export const getLastKnownPositionAsync    = () => Promise.resolve(null);
export const geocodeAsync                 = () => Promise.resolve([]);
export const reverseGeocodeAsync          = () => Promise.resolve([]);
export const enableNetworkProviderAsync   = () => Promise.resolve();

export const Accuracy = { Lowest: 1, Low: 2, Balanced: 3, High: 4, Highest: 5, BestForNavigation: 6 };
export const ActivityType = { Other: 1, AutomotiveNavigation: 2, Fitness: 3, OtherNavigation: 4, Airborne: 5 };
export const GeofencingEventType = { Enter: 1, Exit: 2 };
export const GeofencingRegionState = { Unknown: 0, Inside: 1, Outside: 2 };

export default {
  getForegroundPermissionsAsync, getBackgroundPermissionsAsync,
  requestForegroundPermissionsAsync, requestBackgroundPermissionsAsync,
  getCurrentPositionAsync, watchPositionAsync,
  stopLocationUpdatesAsync, startLocationUpdatesAsync,
  hasStartedLocationUpdatesAsync, getLastKnownPositionAsync,
  geocodeAsync, reverseGeocodeAsync, enableNetworkProviderAsync,
  Accuracy, ActivityType, GeofencingEventType, GeofencingRegionState,
};
